import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import InputSearch from 'components/common/forms/InputSearch/InputSearch';

const InputWithUnmaunt = ({ unmauntFunc, ...props }) => {
  useEffect(() => {
    if (unmauntFunc) {
      return () => {
        unmauntFunc();
      };
    }
  }, [unmauntFunc]);

  return <InputSearch {...props} />;
};

InputWithUnmaunt.propTypes = {
  unmauntFunc: PropTypes.func
};

export default InputWithUnmaunt;
